import {Card, Divider, Row, Col, Modal, Input, InputNumber} from 'antd';
import {useState} from 'react';
import {fixedToDisplayUnit, getUnitPrecision} from "../../util/unitutils";
import {BankSelectWidget} from "../widget/BankSelectWidget";


const {TextArea} = Input;

export const ReturnModal = ({open, invoice, invoiceLine, onOk, onCancel, onApiFail, props}) => {
    const rowStyle = {paddingTop: '5px', paddingBottom: '5px'}
    const [refundAmount, setRefundAmount] = useState(0);
    const [quantity, setQuantity] = useState(0);
    const [accountId, setAccountId] = useState(undefined);
    const [notes, setNotes] = useState("");

    if (invoiceLine === undefined) {
        return <div></div>
    }

    const clearValues = () => {
        setQuantity(0);
        setAccountId(undefined);
        setNotes("");
        setRefundAmount(0);
    }

    const onModalOk = () => {
        if (onOk) onOk(quantity, refundAmount, accountId, notes);
        clearValues();
    }

    const onQuantityChange = (val) => {
        setQuantity(val);
    }

    const onRefundChange = (val) => {
        setRefundAmount(val);
    }

    const onNotesChange = (e) => {
        setNotes(e.target.value);
    }

    const displayQuantity = fixedToDisplayUnit(invoiceLine.quantity, invoiceLine.unit);
    const price = parseFloat(invoiceLine.linePrice);
    const discount = parseFloat(invoiceLine.lineDiscount);

    const okDisabled = (quantity === 0) || (refundAmount <= 0) || (accountId === undefined);
    return <Modal title={'Enter Details for Return'} open={open} okButtonProps={{disabled: okDisabled}} onOk={onModalOk} onCancel={onCancel}>
        <Card>
            <Row style={rowStyle}><b>{invoice.invoiceNumber}</b></Row>
            <Row style={rowStyle}>
                <Col span={6}>{displayQuantity}</Col>
                <Col span={6}>{invoiceLine.name}</Col>
            </Row>
            <Row style={rowStyle}>
                <Col span={6}>Unit Price</Col>
                <Col span={6}>{`$ ${invoiceLine.linePrice / displayQuantity}`}</Col>
            </Row>
            <Row style={rowStyle}>
                <Col span={6}>Discount</Col>
                <Col span={6}>{`$ ${invoiceLine.lineDiscount}`}</Col>
            </Row>
            <Row style={rowStyle}>
                <Col span={6}>Sale Price</Col>
                <Col span={6}>{`$ ${(price - discount)}`}</Col>
            </Row>
            <Divider />
            <Row style={rowStyle}>
                <InputNumber onChange={onQuantityChange} min={0} max={displayQuantity} precision={getUnitPrecision(invoiceLine.unit)} placeholder={'Quantity'}/>
            </Row>
            <Row style={rowStyle}>
                <InputNumber onChange={onRefundChange} addonBefore={"$"} min={0} max={invoiceLine.linePrice - invoiceLine.lineDiscount} precision={2} placeholder={'Refund'} />
            </Row>
            <Row style={rowStyle}>
                <BankSelectWidget onApiFail={onApiFail} bankId={accountId} setAccountId={setAccountId} />
            </Row>
            <Row style={rowStyle}>
            <TextArea placeholder={'notes'} value={notes} onChange={onNotesChange} maxLength={256} rows={4} showCount />
            </Row>
        </Card>
    </Modal>
}